'use client'

import AppContext from "AppContext";
import GeneralForm from "components/GeneralForm";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { validate } from "components/validateGeneralForm";
import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Container, FormGroup, Input } from "reactstrap";
import cameraService from "services/CameraService";
import { erroInesperado } from "services/Utils";

export default function FormCamera() {
  const [data, setData] = useState({})
  const [edit, setEdit] = useState(false)
  const params = useParams()
  const navigate = useNavigate()
  const {state} = useContext(AppContext)

  const idCruzamento = parseInt(params.idCruzamento)
  const id = parseInt(params.id)
  const novo = (0 === id)

  const podeGerenciar = useMemo(() => {
    return (state?.user?.acoes || []).includes('camera.gerenciar')
  }, [state])

  useEffect(() => {
    if (!!id) {
      cameraService.getById(id).then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
    } else {
      setData({
        idCruzamento
      })
    }
  }, [id])

  useEffect(() => {
    if (novo) {
      setEdit(true)
    }
  }, [novo])

  const formConfig = [
      [
        { name: "codigo", label: 'Código', type: "text", required: true, colspan: 4 },
        { name: "url", label: 'URL', type: "text", required: true, colspan: 8 },
      ]
    ]

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      if (novo) {
        await cameraService.create(data)
      } else {
        await cameraService.update(id, data)
      }
      toast('Registro salvo com sucesso!')
      navigate('/admin/cruzamentos/' + idCruzamento + '?aba=cameras')
    } catch (ex) {
      erroInesperado()
    }

  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Câmeras" edit={edit} onChangeEdit={setEdit} showButton={!novo && podeGerenciar} />
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <GeneralForm
              config={formConfig}
              data={data}
              onChange={handleChange}
              disabled={!edit}
            />
            {edit && (
              <Button type="submit" color="primary">Salvar</Button>
            )}
          </form>
        </CardBody>
      </Card>
    </Container>
  )
}